import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog,MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { BaseComponent } from 'src/app/base/base.component';
import { ErrorReportingService } from 'src/app/services/errorReporting/error-reporting.service';

export class FieldSelectionItem {
    name: string;
    dataType: string;
    color: string;

    constructor(name: string, dataType: string, color: string) {
      this.name = name;
      this.dataType = dataType;
      this.color = color;
    }
}

@Component({
  selector: 'app-expression-editor',
  templateUrl: './expression-editor.component.html',
  styleUrl: './expression-editor.component.css',
  standalone: false
})
export class ExpressionEditorComponent extends BaseComponent implements OnInit{
  title: string;
  ruleNo: number;
  ruleName: string;
  targetField: string;
  fields: FieldSelectionItem[]=[];
  expression: string='';

  displayedColumns: string[] = ['field', 'type', 'action'];
  dataSource: MatTableDataSource<any>;
  operators = ['+', '-', '*', '/', '**', '(', ')', "'"];

  @ViewChild('editor') editor!: ElementRef;
  onClosed?: (items: string, eventname: string) => any;

  constructor(
    private dialogRef: MatDialogRef<ExpressionEditorComponent>,
    @Inject(MAT_DIALOG_DATA) private dialogData,
    errorLogger: ErrorReportingService,
    matDialog: MatDialog) {

      super(errorLogger, matDialog);
  }

  async ngOnInit(): Promise<void> {
    this.onClosed = this.dialogData?.onClosed;
    this.title = this.dialogData.title;
    this.ruleNo = this.dialogData.ruleNo;
    this.ruleName = this.dialogData.ruleName;
    this.targetField = this.dialogData.targetField;
    this.expression = this.dialogData.items;
    this.fields = this.dialogData.fields;
    this.dataSource=new MatTableDataSource(this.fields);
  }

  ngAfterViewInit() {
    if (this.expression) {
      this.editor.nativeElement.innerHTML = this.expression;
      // add neutral text node like insertNodeAtCursor
      this.editor.nativeElement.appendChild(document.createTextNode('\u00A0'));
    }
    this.setCursorToEnd();
  }

  setCursorToEnd() {
    const el = this.editor.nativeElement;
    el.focus();

    const range = document.createRange();
    range.selectNodeContents(el);
    range.collapse(false); // move to end

    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
  }

  insertField(field: string, color: string) {
    const span = document.createElement('span');
    span.textContent = field;
    span.style.color = color;

    this.insertNodeAtCursor(span);
  }

  insertOperator(op: string) {
    const span = document.createElement('span');
    span.textContent = op;
    span.style.color = '#5B9BD5';

    this.insertNodeAtCursor(span);
  }

  insertNodeAtCursor(node: HTMLElement) {
    const editor = this.editor.nativeElement;
    const selection = window.getSelection();

    let range: Range | null = null;

    if (selection && selection.rangeCount > 0) {
      const currentRange = selection.getRangeAt(0);

      if (editor.contains(currentRange.startContainer)) {
        range = currentRange;
      }
    }

    if (!range) {
      range = document.createRange();
      range.selectNodeContents(editor);
      range.collapse(false);
    }

    const selectionObj = window.getSelection();
    selectionObj.removeAllRanges();
    selectionObj.addRange(range);

    // check character before cursor
    const startContainer = range.startContainer;
    const offset = range.startOffset;

    let needSpaceBefore = false;

    if (startContainer.nodeType === Node.TEXT_NODE) {
      const text = startContainer.textContent || '';
      if (offset > 0 && text[offset - 1] !== ' ' && text[offset - 1] !== '\u00A0') {
        needSpaceBefore = true;
      }
    }

    if (needSpaceBefore) {
      const spaceBefore = document.createTextNode('\u00A0');
      range.insertNode(spaceBefore);
      range.setStartAfter(spaceBefore);
      range.collapse(true);
    }

    range.deleteContents();
    range.insertNode(node);

    // space after node
    const spaceAfter = document.createTextNode('\u00A0');
    node.parentNode?.insertBefore(spaceAfter, node.nextSibling);

    const newRange = document.createRange();
    newRange.setStartAfter(spaceAfter);
    newRange.collapse(true);

    selectionObj.removeAllRanges();
    selectionObj.addRange(newRange);

    editor.focus();
  }

  save(): void {
    this.expression = this.getExpression();
    this.dialogRef.close({items: this.expression,eventname:'save'});
  }

  cancel(): void {
    this.dialogRef.close({items: this.expression,eventname:'cancel'});
  }
  getExpression(): string {
    let result = '';
    const nodes = this.editor.nativeElement.childNodes;
    nodes.forEach((node: any) => {
      result += node.textContent;
    });

     return result
      .replace(/\u00A0/g, ' ')   // remove non-breaking spaces
      .replace(/\s+/g, ' ')      // normalize spaces
      .trim();
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
}
